export default {
  PrivacyPolicy: require('./PrivacyPolicy.vue').default,
  ModalSiapKerja: require('./ModalSiapKerja.vue').default,
}